
export enum DimensionSourceCd {
	COMMODITY = 'Commodity',
	HANDLING_UNIT = 'HandlingUnit',
	LINEHAUL = 'Linehaul'}
